import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'cva-standalone-transcript-overlay',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './transcript-overlay.component.html',
  styleUrl: './transcript-overlay.component.scss',
})
export class TranscriptOverlayComponent {
  @Input() recording = false;
  @Input() hasTranscript = false;
}
